module.exports = __webpack_public_path__ + "media/assets/images/flags/me-53f1adf0342b6d1102f8a7c989f96eb4.svg";